var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoldStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10081 3.60526C6.94524 2.09042 7.36746 1.33301 7.9987 1.33301C8.62994 1.33301 9.05216 2.09042 9.89659 3.60526L10.1151 3.99716C10.355 4.42763 10.475 4.64287 10.6621 4.78488C10.8491 4.92689 11.0821 4.97961 11.5481 5.08504L11.9723 5.18103C13.6121 5.55204 14.432 5.73755 14.6271 6.36483C14.8221 6.9921 14.2632 7.64572 13.1453 8.95296L12.8561 9.29116C12.5384 9.66263 12.3796 9.84837 12.3081 10.0782C12.2367 10.3079 12.2607 10.5557 12.3087 11.0514L12.3524 11.5026C12.5214 13.2467 12.606 14.1188 12.0953 14.5065C11.5846 14.8942 10.8169 14.5407 9.28158 13.8338L8.88437 13.6509C8.44808 13.45 8.22993 13.3496 7.9987 13.3496C7.76746 13.3496 7.54932 13.45 7.11302 13.6509L6.71581 13.8338C5.18048 14.5407 4.41282 14.8942 3.90213 14.5065C3.39145 14.1188 3.47595 13.2467 3.64496 11.5026L3.68869 11.0514C3.73672 10.5557 3.76073 10.3079 3.68927 10.0782C3.61782 9.84837 3.45898 9.66263 3.14131 9.29116L2.8521 8.95296C1.7342 7.64572 1.17525 6.9921 1.37031 6.36483C1.56538 5.73755 2.38527 5.55204 4.02506 5.18103L4.44929 5.08504C4.91527 4.97961 5.14825 4.92689 5.33533 4.78488C5.5224 4.64287 5.64238 4.42763 5.88234 3.99716L6.10081 3.60526Z",
    fill: "#FACC15"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoldStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/goldStar.46dd4f8b6bd0f45fc20bfbfab563ee15.svg";